// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add to cart";
let default_addedToCartText = "ADDED TO CART!";
let default_add_all_to_cart_text = "Add all to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No Products Found";
let product_count =0;
let add_to_cart_list =[];

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

const tagImageMap = {
  normal:'https://file.tangent.ai/quiz-content/merchants/00736a-81/image/16230334433964355-Normal-Combination-selfie-placeholder.jpg',
  combination:'https://file.tangent.ai/quiz-content/merchants/00736a-81/image/6817544493062069-combination-skintype-selfie-default.jpg',
  oily:'https://file.tangent.ai/quiz-content/merchants/00736a-81/image/15364505134676354-Oily-Congested-selfie-placeholder.jpg',
  sensitive:'https://file.tangent.ai/quiz-content/merchants/00736a-81/image/8084027469931425-Sensitive-Dehydrated-selfie-placeholder.jpg',
  dry:'https://file.tangent.ai/quiz-content/merchants/00736a-81/image/4113579049133642-dry-skintype-selfie-default.jpg'
}

// Add default image url here
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

let tangent_client_domain_currency;
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

const tangent_add_all_to_cart_text = document.querySelector("#tangent-add-to-cart-text"); 

const tangent_response_id = getClientResponseId();
checkoutDataApiCall(tangent_response_id);

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText+" "; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
      setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
      enableButtonListener();
      loadElementsOnResponseData();
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          const variant = getSelectedVariant(product, selected_variants[product.id]).node;
          if(isProductAvailable(product, variant)){
            
            // Track selected product variant
            tangent_selected_product_map[product.id] = getVariantIdFiltered(variant.id);
            
            // Generate product HTML and append it to the fragment
            const product_html = getProductHTML(product, p, variant, section, product_ids);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = product_html;
  
            // Append the created product HTML to the fragment
            while (tempDiv.firstChild) {
              fragment.appendChild(tempDiv.firstChild);
            }
          }
        }
      }
    }

    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => getVariantIdFiltered(variant.node.id) === selectedVariantId) || productVariants[0];
  }
  
  return productVariants[0];
}

function getVariantIdFiltered(id){
  const variantId = Number(id.replace("gid://shopify/ProductVariant/",''));
  return variantId;
}

function getProductHTML(product, index, variant, section, product_ids) {
  // Setting default / first variant data
  const variant_image_url = product.images.nodes[0].url;
  const variantId = getVariantIdFiltered(variant.id);
  const variant_product_url = `${product.onlineStoreUrl}?variant=${variantId}`;
  
  const productDescription = getProductDescription(product);

  const productUsage = getProductUsage(product);

  const productBenefits = getProductBenefits(product);

  let variantTitle= variant.title;
  let variantTitleSection = `<p class="tangent_variant_title">${variantTitle}</p>`;
  if(variantTitle=="Default Title"){
    variantTitleSection="";
  }
  
  updateAllToCartLink(variantId);
  
  // Product View HTML using template literals
  const product_html = `
    <div>
      <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
        <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
        <p class="tangent-product-title tangent_product_title_text"><b>${product.title}</b></p>
        ${variantTitleSection}
        ${productDescription}
        <p id="price_tangent_product_${index}" class="tangent_product_price_text">${tangent_client_domain_currency}${variant.price}</p>
      </a>
      <div id="${section}_variant_${index}"></div>
      <button class="tangent-btn-add tangent_add_to_cart_button tangent-product-add-btn-wrapper" id="${variantId}">
        ${default_addToCartText}
      </button>
      ${productUsage}
      ${productBenefits}
    </div>
  `;
  
  return product_html;
}

const getProductDescription = (product) => {
  let defaultDescription = `<p class="tangent_variant_description">&nbsp;</p>`;

  if (product?.shortDescription?.value?.trim()) {
    return `<p class="tangent_variant_description">${product.shortDescription.value.trim()}</p>`;
  }

  return defaultDescription;
}

const getProductUsage = (product) => {
  let defaultUsage = `<p class="tangent_variant_usage">&nbsp;</p>`;

  if (product?.productUsage?.value?.trim()) {
    return `<p class="tangent_variant_usage"><b>Product Usage</b>:<br> ${product.productUsage.value.trim()}</p>`;
  }

  return defaultUsage;
}

const getProductBenefits = (product) => {
  let defaultBenefits = `<p class="tangent_variant_benefit">&nbsp;</p>`;

  if (product?.productBenefits?.value?.trim()) {
    return `<p class="tangent_variant_benefit"><b>Product Benefit</b>:<br> ${product.productBenefits.value.trim()}</p>`;
  }

  return defaultBenefits;
}

function isProductAvailable(product, variant) {
  return product?.status?.toLowerCase() === "active" && variant?.available_for_sale;
}

// Updating add all to cart object for sections
function updateAllToCartLink(variant_id) {
  let product_cart_obj = {
    'id': variant_id,
    'quantity': 1
  }
  add_to_cart_list.push(product_cart_obj);
}

function addAllToCartFunction(button) {
  // Reuse the generalized function
  handleCartUpdate(
    add_to_cart_list,
    button,
    "Added All to Cart!",
    "Failed to Add Items!"
  );
}


function addToCart(button) {
  console.log(button);
  // Validate the button and its ID
  const variantId = Number(button?.id);

  // Prepare the single item array
  const items = [{ id: variantId, quantity: 1 }];

  // Reuse the generalized function
  handleCartUpdate(
    items,
    button,
    default_addedToCartText || "Added to Cart!",
    "Failed to Add!"
  );
}

function handleCartUpdate(items, button, successText, errorText) {

  // Prepare the API URL
  const cartAddUrl = `${window.Shopify.routes.root}cart/add.js`;
  button.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  // Prepare the request payload
  const formData = { items };
  console.log(formData);
  // Perform the fetch request
  fetch(cartAddUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to add items to cart. Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {

      // Update button UI on success
      if (button) {
        button.textContent = successText || "Added to Cart!";
        button.classList.add("added-to-cart-style");
      }

      // Dispatch custom events for cart updates
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(error => {
      console.error("Error adding items to cart:", error);

      // Update button UI on error
      if (button) {
        button.textContent = errorText || "Failed to Add!";
        button.classList.add("error-style");
      }
    });
}


const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else if(section_name == "section_additional_product"){
              var section_additional = document.querySelector("#section_additional_content_container_parent");
              section_additional.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
          document.querySelector('#tangent_selfie_image').src = getDefaultImageBasedOnTag(response.tags)
        }
    }
}

function getDefaultImageBasedOnTag(tags) {
  const expectedTags = new Set(["oily", "normal", "sensitive","combination","dry"]);
  const matchedSkinType = tags.find(tag => expectedTags.has(tag));
  return matchedSkinType ? tagImageMap[matchedSkinType] : 
    "https://cdn.shopify.com/s/files/1/0866/3308/7264/files/Screenshot_2024-12-17_at_5.08.55_PM.png?v=1734436451";
}

function enableButtonListener() {
    // Listener for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    all_btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
            addToCart(this);
        }, false);
    });
}

function loadElementsOnResponseData() {
  let all_elements = document.querySelectorAll('.load-on-data');
  all_elements.forEach(function(element) {
    element.style.display = "block";
  });
  tangent_add_all_to_cart_text.style.display="block";
}
  

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}
